export class PermissionType{

    public static readonly NONE:number = 0;
    public static readonly VIEW:number = 1;
    public static readonly EDIT:number = 2;
    public static readonly DRILLDOWN:number = 3;

    public PermissionTypeId:number;
    public Name:string;
    public Description:string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/permission-type.ts